import React, {createContext, useCallback, useEffect, useState} from 'react'

import {useWallet} from 'use-wallet'
import useSushi from '../../hooks/useSushi'


import {getFarms} from '../../sushi/utils'

import Context from './context'
import {Farm, FarmsContext} from './types'
import {AppConfig} from "../../config";
import Web3 from "web3";
import {provider} from "web3-core";

let current:number = 0;
let farmsList:Farm[] = [];

const Farms: React.FC = ({children}) => {
    const [unharvested, setUnharvested] = useState(0);
    const [block, setBlock] = useState(0);
    const [farms, setFarms] = useState<Farm[]>([]);
    const [allPremium, setAllPremium] = useState(0);
    const sushi = useSushi();
    const {ethereum,balance}: { ethereum: provider,balance:any } = useWallet();

    const callBack = useCallback(async ()=>{
        const web3 = new Web3(ethereum);
         const latestBlockNumber = await web3.eth.getBlockNumber((ev,blockNumber)=> true);
         if (current !== latestBlockNumber) {

             setBlock(latestBlockNumber);
             current = latestBlockNumber;
         }


    },[block,ethereum,farms]);

    useEffect(() => {

        if (sushi && unharvested === 0) {
            farmsList = getFarms(sushi);
            setFarms(farmsList);
        }
        if (!ethereum) return;
        const interval = setInterval(async () => {
            callBack();
        }, 1000);
        return () => clearInterval(interval)

    }, [sushi]);


    return (
        <Context.Provider
            value={{
                farms,
                unharvested,
                setUnharvested,
                allPremium,
                blockNumber:block,
                allReward: AppConfig.allReward
            }}
        >
            {children}
        </Context.Provider>
    )
};


export default Farms
